export enum ThemeColor {
    PRIMARY = "primary",
    SUCCESS = "success",
    INFO = "info",
    WARNING = "warning",
    DANGER = "danger",
}
